import React, { useEffect, useRef, useState, useContext } from "react";
import AppContext from "../../context/Context";
import FalconCloseButton from '../../components/common/FalconCloseButton';
import { Button, Modal, CloseButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  useNavigate } from "react-router-dom";

const StaticPopup = ({
  message,
  title,
  isShow,
  link,
  btnText_1,
  btnText_2,
  page,
  handleClosePopup,
  handleBtnClick,
  closebtn
}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const navigate = useNavigate()
  const [show, setShow] = useState(isShow);
  useEffect(() => {
     setShow(isShow);
  }, [isShow]);  

  const handleClose = () =>{ setShow(false);handleClosePopup()};
  const redirectToPage = (to) => {
    if(page == "trading/broker-accounts") {
      window.open(to, '_blank');
    } else {
      navigate(to);
      handleClose()
    }
  }
  
      return (
        <Modal className="static_popup " size="md" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
             <Modal.Title className="text-danger fs-1 d-flex align-items-center">       
               <FontAwesomeIcon icon={"info-circle"} className="fs-3 me-2" />{title}
             </Modal.Title>
             {closebtn && <FalconCloseButton onClick={handleClose}/>}
            </Modal.Header>
            <Modal.Body className="text-primary">
             {message?.map((des, index) => (
              <div key={"d-"+index}>
                 {des!="spaceLine" && des} {des == "spaceLine" && <p></p>} 
              </div>
            ))}
            </Modal.Body>
            <Modal.Footer>
               {btnText_2 &&
                <Button onClick={()=>page == "discover/pricing/plan" ? handleBtnClick("no") : handleClose()} variant="outline-primary">
                {btnText_2}
               </Button >
              }
              {btnText_1 &&
               <Button  variant="primary" onClick={()=>page == "discover/pricing/plan" ? handleBtnClick("yes") :redirectToPage(link)}>
                  {btnText_1} 
               </Button>
              }

            </Modal.Footer>
        </Modal>
      );
    
};

export default StaticPopup;
